import { create } from '@theme/create';

export const themed = create(
  new (function () {
    (this.sidebar = {
      price: {
        variant: 'flex.row.between.center',
        mb: 4,

        title: {
          variant: 'text.h5',
          mr: 4,
        },

        amount: {
          variant: 'text.base',
          textAlign: 'right',
        },
      },
    }),
      // cart empty — rendered in /cart
      (this.page = {
        price: {
          ...this.sidebar.price,

          title: {
            variant: 'text.h5',
            mr: 4,
          },

          amount: {
            variant: 'text.base',
            textAlign: 'right',
          },
        },
      });
  })()
);
